module.exports = __webpack_public_path__ + "assets/4e30bc14964527b0e6b9b8a520845742.png";